import React from "react";

const Select = ({ label, error, touched, options, ...props }) => {
  return (
    <>
      <label>{label}</label>
      <select {...props}>
        <option label="Select Option" disabled />
        {options?.map((option) => (
          <option
            key={option?.value}
            value={option?.value}
            label={option?.label}
          >
            {option?.label}
          </option>
        ))}
      </select>

      {touched && error ? <p className="text-danger">{error}</p> : null}
    </>
  );
};

export default Select;
